<template>
  <b-modal
      :visible="visible"
      ref="modal"
      id="admin-production-type-add-modal"
      title="Add New Production Type"
      @hidden="$emit('cancel')"
      hide-footer
      centered
  >
    <b-form @submit.prevent="submitForm">
      <b-form-group label="Production Type Name">
        <b-form-input
            v-model.trim="formData.name"
            type="text"
            :state="fieldValid('name')"
        />
        <b-form-invalid-feedback :state="fieldValid('name')">
          {{ formValidation.name }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Category Types">
        <div
            v-for="(categoryTypeId, index) in formData.category_types"
            :key="index"
        >
          <b-input-group>
            <b-form-select
                v-model="formData.category_types[index]"
                :options="categoryTypes"
                :state="categoryTypeValid(index)"
            />
            <b-input-group-append>
              <b-button title="remove category type" v-if="formData.category_types.length > 1" variant="danger" @click.prevent="removeCategoryType(index)">
                <b-icon-x/>
              </b-button>
              <b-button title="add category type" variant="success" @click.prevent="addCategoryTypeRow">
                <b-icon-plus/>
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <b-form-invalid-feedback v-if="categoryTypeValid(index) === false" :state="categoryTypeValid(index)">
            {{ formValidation[`category_types.${index}`].replace(`category_types.${index}`, 'category type') }}
          </b-form-invalid-feedback>
          <hr v-if="formData.category_types.length > 1">
        </div>
      </b-form-group>
      <b-button type="submit" variant="success" :disabled="formState.processing">
        Submit
        <b-spinner v-if="formState.processing" class="ml-1" small></b-spinner>
      </b-button>
      <b-btn type="button" variant="secondary" @click.prevent="close">Cancel</b-btn>
    </b-form>
  </b-modal>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminProductionTypeAddModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        name: "",
        category_types: ['']
      },
      formValidation: {},
      formState: {
        processing: false
      }
    }
  },
  computed: {
    categoryTypes() {
      return this.$store.state.data.category_types.map(ct => ({
        value: ct.id,
        text: ct.name
      }));
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-production-type-add-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-production-type-add-modal');
    },
    fieldValid(field) {
      return typeof this.formValidation[field] !== "undefined" && this.formValidation[field].length > 0 ? false : null;
    },
    categoryTypeValid(index) {
      return typeof this.formValidation[`category_types.${index}`] !== "undefined" && this.formValidation[`category_types.${index}`].length > 0 ? false : null;
    },
    addCategoryTypeRow() {
      this.formData.category_types.push('');
    },
    removeCategoryType(index) {
      if (this.formData.category_types.length > 1 && typeof this.formData.category_types[index] !== 'undefined') {
        let category_types = [...this.formData.category_types];
        category_types.splice(index, 1);
        this.formData.category_types = category_types;
        for (let validationKey in this.formValidation) {
          if (validationKey.indexOf('category_types') === 0) {
            delete this.formValidation[validationKey];
          }
        }
      }
    },
    submitForm() {
      this.formState.processing = true;
      this.$api.post(API_ROUTES.ADMIN_TAXONOMY_PRODUCTION_TYPES, this.formData).then(({data}) => {
        this.formValidation = {};
        this.$emit('success', data.production_type);
        this.formData = {
          name: "",
          category_types: ['']
        };
        this.close();
      }).catch(({response: {data}}) => {
        this.$bvToast.toast(data.message ?? 'Failed to create a new production type', {
          title: 'Error!',
          variant: 'danger'
        });
        let validationErrors = {};
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in data.errors) {
            validationErrors[fieldName] = data.errors[fieldName].join(', ');
          }
        }
        this.formValidation = validationErrors;
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
